export const siteConfig = {
  name: '中文字幕日韩影视大全',
  tagline: '最全中文字幕日韩资源平台',
  description: '专注中文字幕日韩影视资源，涵盖日韩电影、电视剧、综艺全品类，高清画质配精准中文字幕，随时随地畅享原汁原味的日韩文化娱乐体验，海量更新不断档。',
  keywords: '中文字幕日韩,中文字幕日韩电影,中文字幕日韩电视剧,日韩综艺中文字幕,高清中文字幕日韩资源,日韩影视在线观看,日韩中字最新更新',
  url: 'https://netpaw.cn',
  email: 'contact@rhzyysdq.com',
  phone: '400-888-6666',
  address: '北京市朝阳区影视产业园A座',
  social: {
    weibo: 'https://weibo.com/rhzyysdq',
    wechat: 'rhzyysdq',
    bilibili: 'https://bilibili.com/rhzyysdq',
  },
};

export const categories = [
  { slug: 'movie', name: '日韩电影', icon: 'ri-film-line', description: '最新最全日韩电影，高清中文字幕在线观看' },
  { slug: 'drama', name: '日韩电视剧', icon: 'ri-tv-line', description: '热门日韩电视剧第一时间更新中字' },
  { slug: 'variety', name: '日韩综艺', icon: 'ri-emotion-laugh-line', description: '搞笑治愈日韩综艺中文字幕版' },
  { slug: 'anime', name: '动漫番剧', icon: 'ri-rocket-line', description: '日韩动漫新番中文字幕同步更新' },
  { slug: 'documentary', name: '纪录片', icon: 'ri-global-line', description: '日韩精品纪录片中文字幕版' },
];

export const featuredContent = [
  {
    id: 1,
    title: '浪客剑心 最终章',
    titleEn: 'Rurouni Kenshin: The Final',
    category: 'movie',
    categoryName: '日韩电影',
    year: 2021,
    rating: 8.9,
    imageUrl: 'https://readdy.ai/api/search-image?query=Rurouni%20Kenshin%20film%20poster%20style%2C%20samurai%20in%20red%20kimono%20holding%20katana%20against%20dark%20dramatic%20background%2C%20cinematic%20lighting%2C%20Japanese%20period%20drama%20aesthetic%2C%20movie%20poster%20composition%2C%20clean%20minimal%20backdrop%20with%20warm%20golden%20accents&width=400&height=600&seq=rurouni-kenshin-final&orientation=portrait',
    summary: '明治时代的传奇剑客绯村剑心，面对前所未有的强敌，展开最终决战。',
    tags: ['动作', '历史', '佐藤健'],
  },
  {
    id: 2,
    title: '寄生虫',
    titleEn: 'Parasite',
    category: 'movie',
    categoryName: '日韩电影',
    year: 2019,
    rating: 9.3,
    imageUrl: 'https://readdy.ai/api/search-image?query=Parasite%20Korean%20film%20poster%20style%2C%20modern%20family%20drama%20with%20dark%20undertones%2C%20stark%20contrast%20between%20rich%20and%20poor%2C%20minimalist%20composition%20on%20neutral%20beige%20backdrop%2C%20Oscar%20winning%20cinema%20aesthetic%2C%20clean%20sophisticated%20movie%20poster&width=400&height=600&seq=parasite-movie&orientation=portrait',
    summary: '两个家庭之间微妙的寄生关系，揭示社会阶层的残酷现实。',
    tags: ['剧情', '悬疑', '奉俊昊'],
  },
  {
    id: 3,
    title: '半泽直树 第二季',
    titleEn: 'Hanzawa Naoki Season 2',
    category: 'drama',
    categoryName: '日韩电视剧',
    year: 2020,
    rating: 9.4,
    imageUrl: 'https://readdy.ai/api/search-image?query=Hanzawa%20Naoki%20Japanese%20drama%20poster%20style%2C%20businessman%20in%20sharp%20suit%20with%20intense%20expression%2C%20corporate%20Tokyo%20backdrop%2C%20dramatic%20cinematic%20lighting%2C%20clean%20modern%20drama%20poster%20composition%2C%20warm%20golden%20tone&width=400&height=600&seq=hanzawa-naoki-s2&orientation=portrait',
    summary: '银行职员半泽直树再度回归，以牙还牙加倍奉还的职场逆袭。',
    tags: ['职场', '剧情', '堺雅人'],
  },
  {
    id: 4,
    title: 'Running Man',
    titleEn: 'Running Man',
    category: 'variety',
    categoryName: '日韩综艺',
    year: 2024,
    rating: 9.1,
    imageUrl: 'https://readdy.ai/api/search-image?query=Running%20Man%20Korean%20variety%20show%20poster%20style%2C%20energetic%20cast%20running%20together%2C%20bright%20playful%20composition%2C%20vibrant%20colors%20on%20clean%20white%20backdrop%2C%20entertainment%20show%20aesthetic%2C%20fun%20dynamic%20atmosphere&width=400&height=600&seq=running-man-variety&orientation=portrait',
    summary: '韩国最长寿户外综艺，爆笑游戏与激烈追逐的完美结合。',
    tags: ['综艺', '搞笑', '竞技'],
  },
  {
    id: 5,
    title: '鬼灭之刃 无限列车篇',
    titleEn: 'Demon Slayer: Mugen Train',
    category: 'anime',
    categoryName: '动漫番剧',
    year: 2020,
    rating: 9.5,
    imageUrl: 'https://readdy.ai/api/search-image?query=Demon%20Slayer%20anime%20movie%20poster%20style%2C%20flame%20hashira%20with%20burning%20sword%2C%20dramatic%20fire%20effects%20on%20dark%20background%2C%20Japanese%20animation%20aesthetic%2C%20clean%20composition%20with%20vibrant%20warm%20tones&width=400&height=600&seq=demon-slayer-mugen&orientation=portrait',
    summary: '灶门炭治郎与炎柱炼狱杏寿郎登上无限列车，迎战上弦之鬼。',
    tags: ['热血', '战斗', '动画'],
  },
  {
    id: 6,
    title: '东京大饭店',
    titleEn: 'Grand Maison Tokyo',
    category: 'drama',
    categoryName: '日韩电视剧',
    year: 2019,
    rating: 8.8,
    imageUrl: 'https://readdy.ai/api/search-image?query=Grand%20Maison%20Tokyo%20Japanese%20drama%20poster%20style%2C%20chef%20in%20white%20uniform%20presenting%20gourmet%20dish%2C%20elegant%20restaurant%20atmosphere%2C%20warm%20ambient%20lighting%2C%20clean%20minimalist%20composition%2C%20sophisticated%20culinary%20theme&width=400&height=600&seq=grand-maison-tokyo&orientation=portrait',
    summary: '米其林三星主厨跌落神坛后，召集伙伴重振旗鼓的热血美食故事。',
    tags: ['美食', '励志', '木村拓哉'],
  },
];

export const latestUpdates = [
  {
    id: 7,
    title: '鱿鱼游戏 第二季',
    titleEn: 'Squid Game Season 2',
    category: 'drama',
    categoryName: '日韩电视剧',
    year: 2024,
    rating: 8.7,
    updateInfo: '第8集更新至中字',
    imageUrl: 'https://readdy.ai/api/search-image?query=Squid%20Game%20Korean%20drama%20poster%20style%2C%20mysterious%20masked%20figures%20with%20colorful%20playground%20elements%2C%20dark%20suspenseful%20atmosphere%2C%20clean%20minimalist%20composition%20on%20neutral%20gray%20backdrop%2C%20thriller%20series%20aesthetic&width=400&height=600&seq=squid-game-s2&orientation=portrait',
    summary: '成奇勋重返游戏，揭开神秘组织背后更深层的秘密。',
  },
  {
    id: 8,
    title: '孤独的美食家 第十季',
    titleEn: 'Solitary Gourmet Season 10',
    category: 'drama',
    categoryName: '日韩电视剧',
    year: 2024,
    rating: 9.2,
    updateInfo: '第12集更新至中字',
    imageUrl: 'https://readdy.ai/api/search-image?query=Solitary%20Gourmet%20Japanese%20drama%20poster%20style%2C%20middle%20aged%20man%20enjoying%20delicious%20food%20at%20local%20restaurant%2C%20warm%20cozy%20atmosphere%2C%20clean%20simple%20composition%20on%20beige%20backdrop%2C%20food%20drama%20aesthetic&width=400&height=600&seq=solitary-gourmet-s10&orientation=portrait',
    summary: '井之头五郎继续在全国各地寻找隐藏的美食名店。',
  },
  {
    id: 9,
    title: '破墓',
    titleEn: 'Exhuma',
    category: 'movie',
    categoryName: '日韩电影',
    year: 2024,
    rating: 8.5,
    updateInfo: '高清中字已上线',
    imageUrl: 'https://readdy.ai/api/search-image?query=Exhuma%20Korean%20horror%20film%20poster%20style%2C%20mysterious%20traditional%20Korean%20burial%20site%20in%20misty%20forest%2C%20dark%20supernatural%20atmosphere%2C%20clean%20composition%20on%20dark%20earthy%20backdrop%2C%20horror%20thriller%20cinematic%20aesthetic&width=400&height=600&seq=exhuma-korean&orientation=portrait',
    summary: '风水师与殡葬师受委托迁葬可疑坟墓，引发一连串超自然事件。',
  },
  {
    id: 10,
    title: '非自然死亡',
    titleEn: 'Unnatural',
    category: 'drama',
    categoryName: '日韩电视剧',
    year: 2018,
    rating: 9.1,
    updateInfo: '全集高清中字',
    imageUrl: 'https://readdy.ai/api/search-image?query=Unnatural%20Japanese%20medical%20drama%20poster%20style%2C%20forensic%20doctor%20in%20white%20lab%20coat%20with%20serious%20expression%2C%20clean%20modern%20laboratory%20background%2C%20professional%20medical%20aesthetic%2C%20minimalist%20composition&width=400&height=600&seq=unnatural-jdrama&orientation=portrait',
    summary: '法医们通过解剖揭露真相，每一集都是一个直击人心的故事。',
  },
  {
    id: 11,
    title: '我独自生活',
    titleEn: 'I Live Alone',
    category: 'variety',
    categoryName: '日韩综艺',
    year: 2024,
    rating: 8.9,
    updateInfo: '每周六更新中字',
    imageUrl: 'https://readdy.ai/api/search-image?query=I%20Live%20Alone%20Korean%20variety%20show%20poster%20style%2C%20cozy%20modern%20apartment%20interior%20with%20warm%20lighting%2C%20single%20lifestyle%20theme%2C%20clean%20bright%20composition%2C%20entertainment%20reality%20show%20aesthetic&width=400&height=600&seq=i-live-alone&orientation=portrait',
    summary: '展现独居艺人们真实有趣的日常生活，温暖治愈。',
  },
  {
    id: 12,
    title: '灌篮高手 电影版',
    titleEn: 'The First Slam Dunk',
    category: 'anime',
    categoryName: '动漫番剧',
    year: 2022,
    rating: 9.6,
    updateInfo: '高清中字已上线',
    imageUrl: 'https://readdy.ai/api/search-image?query=The%20First%20Slam%20Dunk%20anime%20movie%20poster%20style%2C%20basketball%20player%20jumping%20for%20slam%20dunk%20silhouette%2C%20dynamic%20sports%20action%2C%20clean%20composition%20with%20dramatic%20lighting%2C%20Japanese%20animation%20classic%20aesthetic&width=400&height=600&seq=slam-dunk-movie&orientation=portrait',
    summary: '湘北高中篮球队在全国大赛中对阵最强山王工业。',
  },
  {
    id: 13,
    title: '重启人生',
    titleEn: 'Brush Up Life',
    category: 'drama',
    categoryName: '日韩电视剧',
    year: 2023,
    rating: 9.3,
    updateInfo: '全集高清中字',
    imageUrl: 'https://readdy.ai/api/search-image?query=Brush%20Up%20Life%20Japanese%20drama%20poster%20style%2C%20young%20woman%20in%20everyday%20Japanese%20town%20setting%2C%20warm%20nostalgic%20atmosphere%2C%20slice%20of%20life%20theme%2C%20soft%20natural%20lighting%2C%20clean%20minimal%20composition&width=400&height=600&seq=brush-up-life&orientation=portrait',
    summary: '普通女性意外死亡后获得重来人生的机会，充满温情与欢笑。',
  },
  {
    id: 14,
    title: '犯罪都市4',
    titleEn: 'The Roundup: Punishment',
    category: 'movie',
    categoryName: '日韩电影',
    year: 2024,
    rating: 8.3,
    updateInfo: '高清中字已上线',
    imageUrl: 'https://readdy.ai/api/search-image?query=The%20Roundup%20Korean%20action%20film%20poster%20style%2C%20tough%20detective%20in%20dark%20urban%20alley%2C%20intense%20crime%20action%20atmosphere%2C%20clean%20composition%20on%20dark%20moody%20backdrop%2C%20police%20thriller%20cinematic%20aesthetic&width=400&height=600&seq=roundup-punishment&orientation=portrait',
    summary: '怪物刑警马锡道再次出击，跨国追捕网络犯罪组织。',
  },
];

export const faqData = [
  {
    question: '网站上的日韩影视资源都有中文字幕吗？',
    answer: '是的，我们平台上的所有日韩电影、电视剧、综艺和动漫都配有精准的中文字幕。我们的字幕团队由资深日韩语翻译组成，确保翻译质量，让您无障碍享受原汁原味的日韩文化内容。',
  },
  {
    question: '如何观看高清中文字幕日韩资源？',
    answer: '您可以直接在网站首页浏览热门推荐和最新更新，或通过分类导航进入日韩电影、日韩电视剧、日韩综艺等专区。点击任意影片即可进入播放页面，支持多种清晰度选择。',
  },
  {
    question: '网站更新频率如何？日韩中字资源更新快吗？',
    answer: '我们保持每日更新的节奏。日韩电视剧一般在播出后24小时内上线中文字幕版本，电影和综艺也会在第一时间更新。您可以关注"最新更新"栏目获取最及时的中文字幕日韩资源。',
  },
  {
    question: '需要注册账号才能观看吗？',
    answer: '目前所有日韩影视资源均可免费在线观看，无需注册。我们致力于为广大日韩影视爱好者提供最便捷的中文字幕观影体验。',
  },
  {
    question: '支持哪些设备观看？画质如何？',
    answer: '我们的网站采用响应式设计，支持电脑、平板和手机等多种设备流畅观看。所有资源均提供高清画质（720P及以上），部分热门内容支持1080P和4K超高清，让您享受最佳的中文字幕日韩观影体验。',
  },
  {
    question: '如何联系我们？对字幕翻译有建议怎么办？',
    answer: '您可以通过关于我们页面的联系方式与我们取得联系，或发送邮件至官方邮箱。我们非常重视用户反馈，会认真对待每一条关于字幕翻译和内容的建议。',
  },
];

export const aboutInfo = {
  brandIntro: '中文字幕日韩影视大全成立于2019年，是国内领先的日韩影视中文字幕资源平台。我们专注为华语观众提供最全面、最优质的中文字幕日韩内容，涵盖电影、电视剧、综艺、动漫等全品类。平台汇聚超过5000部日韩影视作品，累计服务用户超过800万人次，日均活跃用户超过50万。',
  mission: '让每一位喜爱日韩文化的观众，都能跨越语言障碍，以最便捷的方式享受原汁原味的日韩影视内容。',
  features: [
    { title: '资源全面', description: '涵盖日韩电影、电视剧、综艺、动漫、纪录片全品类，超过5000部作品持续扩充中。' },
    { title: '高清画质', description: '所有资源提供720P以上高清画质，热门内容支持1080P/4K，观影体验一流。' },
    { title: '精准中字', description: '专业翻译团队精心制作，确保中文字幕准确传达原文精髓，让您无障碍理解剧情。' },
    { title: '极速更新', description: '日韩电视剧播出后24小时内上线中字，综艺节目48小时内更新，永不断档。' },
    { title: '完全免费', description: '所有日韩影视资源均可免费在线观看，无需注册无需付费，纯粹享受观影乐趣。' },
    { title: '多端适配', description: '支持电脑、平板、手机等多设备观看，随时随地畅享中文字幕日韩内容。' },
  ],
  stats: [
    { value: '5000+', label: '影视资源' },
    { value: '800万+', label: '累计用户' },
    { value: '50万+', label: '日活跃用户' },
    { value: '99.8%', label: '用户好评率' },
  ],
};

export const allContent = [...featuredContent, ...latestUpdates];